// @ts-nocheck
/* eslint-disable */ /* NOTE: Auto-generated. Run `pnpm build-icons` instead of editing. */ import { ReactComponent as CopyADefault } from '../../../../../ui/src/assets/icons/v2.1/mono-tone/default/general/copy-a.svg?react';
import { ReactComponent as CopyASolid } from '../../../../../ui/src/assets/icons/v2.1/mono-tone/solid/general/copy-a.svg?react';
import { createIcons } from '../../Icon';
export const CopyAIcon = /* @__PURE__ */ createIcons('CopyA', {
    default: CopyADefault,
    solid: CopyASolid
});
CopyAIcon.supportedTypes = [
    'default',
    'solid'
];
